<template>
  <div class="cart-wrapper">
    <form v-show="page !== 'history'">
      <div class="task-list" v-show="page === 'tasks'">
        <ul>
          <li 
            v-for="category in tasksByCategory" 
            :key="category.label">
            <section>
              <h4>{{ category.label }}</h4>
              <ul>
                <li v-for="task of category.tasks" 
                  :key="task.name" >
                  <button
                    type="button" 
                    class="task-option"
                    :id="task.name"
                    :disabled="!task.available"
                    @click="loadTask(task)">
                    <div>
                      <label :for="task.name" class="task-option__title">{{ task.display }}</label>
                      <span>{{ task.description }}</span>
                    </div>
                    <ArrowRightIcon v-if="task.available" />
                    <InfoTriangleIcon v-else/>
                  </button>
                </li>
              </ul>
            </section>
          </li>
        </ul>
      </div>
      <div class="task-parameters" v-if="page === 'parameters' && activeTask">
        <button @click="returnToParameters">back</button>
        <h1 @click="console.log(activeTask)">{{ activeTask.display }}</h1>

      </div>
    </form>

    <div class="task-status" v-if="page === 'status'"></div>
    <div class="task-history" v-if="page === 'history'"></div>
    
  </div>
</template>

<script setup lang="ts">
import { Ref, computed, onMounted, ref } from 'vue';
// import { VoyagerCard, VoyagerResult } from 'VoyagerComponents';
import { fetchAvailableTasks, Doc as SolrTaskDefinition } from '../services/LegacyTaskService';
import { useResultsStore } from '@/store/results';
import { useCartStore } from '@/store/cart';
import { useAuthStore } from '@/store/auth';
import { ArrowRightIcon, InfoTriangleIcon } from 'vue-tabler-icons';

const tasks: Ref<SolrTaskDefinition[]> = ref([]);

await fetchAvailableTasks().then(res => {
  tasks.value = res.response.docs;
})

const { getAllCartItemIDs, removeItemFromCart, getReadOnlyCart } = useCartStore();
const { getFieldByDisplayKey } = useResultsStore();
const { username } = useAuthStore();

const emit = defineEmits(['closeCart', 'userAction']);
const cartResults = computed(() => Array.from(getReadOnlyCart().value.values())),
returnToParameters = () => {
  page.value = 'tasks';
  activeTask.value = null;
},
handleUserAction = ($event) => emit('userAction', $event);
const page = <Ref<'tasks' | 'parameters' | 'history' | 'status'>>ref('tasks');
const activeTask = <Ref<any>>ref(null);
const hideUnavailable = ref(true);
const loadTask = (task: any) => {
  activeTask.value = task;
  page.value = 'parameters';
}

type TaskGroup = {
  label: string,
  tasks: any[]
}

const tasksByCategory = computed(() => {
  const groups: Record<string, any[]> = {};
  const taskGroups: TaskGroup[] = []
  tasks.value.forEach(task => {
    task.category.forEach(category => {
      if(!groups[category]) groups[category] = [];
      groups[category].push(task); 
    })
  })
  Object.keys(groups).forEach((groupName, group) => {
    taskGroups.push({
      label: groupName,
      tasks: groups[groupName].toSorted((a,b) => { return a.available ? -1 : 1})
    })
  })
  return taskGroups;
})

</script>

<style lang="scss" scoped>
.cart-wrapper {
  height: 100%;
  width: 100%;
  background-color: var(--app-background);
  gap: 1rem;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}

ul {
  padding: 0rem 1rem;
  gap: .5rem;
  display: flex;
  flex-direction: column;
  list-style: none;
}

li {
  text-decoration: none;
}

.task-option {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-action-background-standard);
  color: var(--color-text-primary);
  border: none;
  border-radius: var(--border-radius);
  padding: 0.5rem;
  &:hover {
    cursor: pointer;
    background-color: var(--color-action-background-primary);
  }
  div {
    display: flex;
    flex-direction: column;
    align-items: start;
    .task-option__title {
      font-size: var(--font-size-large);
      pointer-events: none;
    }
    span {
      text-align: left;
      pointer-events: none;
    }
  }

  svg {
    color: var(--color-text-primary)
  }

  &:disabled {
    background-color: var(--color-action-background-primary-disabled);
    color: black;
    svg {
      color: var(--color-action-secondary)
    }
  }
}
</style>